import React from "react";
// import ReactDOM from 'react-dom';

// Import React FilePond
import {FilePond, registerPlugin} from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

function ImageUpload(props) {
  return (
    <div>
      <FilePond
        onupdatefiles={(fileItems) => {
          props.callFile(fileItems);
        }}
        allowMultiple={true}
        maxFiles={1}
        server="/api"
        labelIdle="Look For Your File (.XML, .PNG, .JPG, .DOC)"
      />
    </div>
  );
}

export default ImageUpload;